<template>
  <div
    class="signup"
    @click="offHospital()"
    v-loading.fullscreen.lock="videoIsUPloding"
  >
    <div class="content">
      <div class="title" v-if="!isUserInfo">个人信息</div>
      <div class="form">
        <el-form
          :label-position="labelposition"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名:" prop="realname">
            <el-input
              v-model="ruleForm.realname"
              class="inputWidth"
              placeholder="请输入您的姓名"
              :disabled="inputState"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="电话号码:"
            prop="contact_phone"
            v-if="!isUserInfo"
          >
            <el-input
              v-model="ruleForm.contact_phone"
              class="inputWidth"
              placeholder="请输入您的电话号码"
              :disabled="inputState"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号:" prop="idcard">
            <el-input
              v-model="ruleForm.idcard"
              class="inputWidth"
              placeholder="请输入您的身份证号"
              :disabled="inputState"
            ></el-input>
          </el-form-item>
          <el-form-item label="职业类型:" prop="job_type">
            <div class="groupBtns">
              <button
                v-for="item in zubieList"
                :key="item.item_value"
                @click.prevent="mygroupChange(item.item_value)"
                :class="ruleForm.job_type == item.item_value ? 'glbtn' : ''"
                :disabled="inputState"
              >
                {{ item.item_name }}
              </button>
            </div>
          </el-form-item>
          <el-form-item label="职称选择:" prop="title_id">
            <el-radio-group v-model="ruleForm.title_id">
              <el-radio
                :disabled="inputState"
                :label="item.id"
                v-for="item in zhichengList"
                :key="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="医院全称:" prop="hospital_name">
            <div class="adress">
              <el-select
                :disabled="inputState"
                v-model="ruleForm.province_id"
                placeholder="请选择省份"
                @change="provinceChange()"
              >
                <el-option
                  v-for="item in mapList.province"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                :disabled="inputState"
                v-model="ruleForm.city_id"
                placeholder="请选择城市"
                @change="cityChange()"
              >
                <el-option
                  v-for="item in mapList.city"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                :disabled="inputState"
                v-model="ruleForm.district_id"
                placeholder="请选择区域"
              >
                <el-option
                  v-for="item in mapList.area"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <el-input
              :disabled="inputState"
              v-model="ruleForm.hospital_name"
              class="inputWidth martop20"
              @input="hospitalChange()"
              placeholder="未搜索到的医院，请手动填写医院名称"
            ></el-input>
            <div
              class="hospitalList"
              v-if="hospitalListIsShow"
              v-loadMore="hospitalDel"
            >
              <ul class="hospitalListMore">
                <li
                  v-for="item in mapList.hospital"
                  :key="item.id"
                  @click.stop="choiceHospital(item)"
                >
                  <p>{{ item.name }}</p>
                </li>
              </ul>
            </div>
          </el-form-item>
          <el-form-item label="科室选择:" prop="department_id">
            <el-radio-group v-model="ruleForm.department_id">
              <el-radio
                :disabled="inputState"
                :label="item.id-0"
                v-for="item in DepartmentList"
                :key="item.id-0"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <div class="title" v-if="!isUserInfo">培训报名信息</div>
          <el-form-item label="期数选择:" prop="training_id" v-if="!isUserInfo">
            <el-select
              :disabled="inputState"
              v-model="ruleForm.training_id"
              placeholder="请选择期数"
              style="width: 100%"
            >
              <el-option
                v-for="item in phaseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训类型：" prop="type" v-if="!isUserInfo">
            <div class="groupBtns">
              <button
                v-for="item in training_typeList"
                :key="item.item_value"
                @click.prevent="mygroupChange2(item.item_value)"
                :class="ruleForm.type == item.item_value ? 'glbtn' : ''"
                :disabled="inputState"
              >
                {{ item.item_name }}
              </button>
            </div>
          </el-form-item>
          <el-form-item
            label="上传证明"
            prop="cert_image"
            style="padding-bottom: 20px"
            v-if="!isUserInfo"
          >
            <div class="uploader">
              <el-upload
                :disabled="inputState"
                class="avatar-uploader"
                accept=".jpg,.png"
                name="file"
                :action="picURL + '/api/upload-image'"
                :show-file-list="false"
                :auto-upload="true"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="ruleForm.cert_image"
                  :src="ruleForm.cert_image"
                  class="avatar"
                />
                <div
                  class="clear"
                  @click.stop="
                    () => {
                      ruleForm.cert_image = '';
                    }
                  "
                  v-if="ruleForm.cert_image"
                >
                  x
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="tit">工作证</span>
              </el-upload>
              <el-upload
                :disabled="inputState"
                class="avatar-uploader"
                accept=".jpg,.png"
                name="file"
                :action="picURL + '/api/upload-image'"
                :show-file-list="false"
                :auto-upload="true"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="ruleForm.unit_cert_image"
                  :src="ruleForm.unit_cert_image"
                  class="avatar"
                />
                <div
                  class="clear"
                  @click.stop="
                    () => {
                      ruleForm.unit_cert_image = '';
                    }
                  "
                  v-if="ruleForm.unit_cert_image"
                >
                  x
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="tit">单位证明&nbsp;&nbsp; </span>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <div class="submitbox">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            class="submit"
            :disabled="workInputState"
            v-if="!isUserInfo"
            >提交</el-button
          >
          <el-button
            type="primary"
            @click="submitForm2('ruleForm')"
            class="submit"
            :disabled="workInputState"
            v-else
            >保存</el-button
          >
        </div>
        <!-- 对话框 -->
      </div>
    </div>
  </div>
</template>
<script>
import { getAreas, searchHospital } from "../views/API/city";
import {
  getBmInfo,
  setBaoming,
  getDictionaries,
  getTitles,
  getDpartments,
  gettrainings,
  updateUserInfo,
} from "../views/API/user";
// import { getToken, hasToken, setToken } from "../assets/js/storage";
export default {
  props: {
    hasRegistered: {
      type: Boolean,
      default: false,
    },
    isUserInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clientWidth: document.body.clientWidth,
      switchValue: false,
      videoIsUPloding: false,
      dialog2: false,
      labelposition:document.body.clientWidth<540?'top':'left',
      picURL: "https://dt.gyycbj.com",
      // 报名表单
      ruleForm: {
        id: null,
        realname: "", //姓名
        idcard: "", //身份证号
        contact_phone: "", //电话
        job_type: "", //组别
        title_id: "", //职称id
        department_id: "", //科室id
        training_id: "", //培训期数id
        province_id: "", //省
        city_id: "", //市
        district_id: "", //区
        hospital_name: "", //医院
        hospital_id: "", //医院id
        type: "", //培训类型
        cert_image: "", //工作证图片
        unit_cert_image: "", //单位证明图片
      },
      // 培训期数列表
      phaseList: [],
      // 培训类型
      training_typeList: [],
      // 职业类型列表
      zubieList: [],
      // 职称列表
      zhichengList: [
        {
          id: 0,
          name: "请先选择参赛组别",
        },
      ],
      // 科室列表
      DepartmentList: [],
      // 请求医院页码
      pageSize: {
        page: 1,
        limit: 20,
      },
      count: 0, //医院总数
      dialogVisible: false, //提示对话框
      hospitalListIsShow: false,
      // 地图列表
      mapList: {
        province: [],
        city: [],
        area: [],
        hospital: [],
      },

      rules: {
        // 姓名
        realname: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          {
            min: 2,
            max: 8,
            message: "长度应在 2 到 8 个字符",
            trigger: "blur",
          },
        ],
        // 电话
        contact_phone: [
          { required: true, message: "请输入您的电话", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
        // 邮箱
        idcard: [
          { required: true, message: "请输入您的身份证号", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/,
            message: "请输入正确的身份证号格式",
            trigger: "blur",
          },
        ],
        // 组别
        job_type: [
          { required: true, message: "请选择您的职业类型", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择您的培训类型", trigger: "blur" },
        ],
        // 科室
        department_id: [
          { required: true, message: "请选择您的科室", trigger: "change" },
        ],
        // 职称
        title_id: [
          { required: true, message: "请选择您的职称", trigger: "change" },
        ],
        // 地区
        city: [
          { required: true, message: "请选择您的区域", trigger: "change" },
        ],
        // 医院
        hospital_name: [
          { required: true, message: "请选择您的医院", trigger: "blur" },
        ],
        // 工作证明
        cert_image: [
          { required: true, message: "请上传您的工作证明", trigger: "blur" },
        ],
      },
      // 输入框状态
      inputState: false,
      workInputState: false,
    };
  },

  created() {
    this.getUserInfoHandle();
    this.getProvince(1); //获取地区下拉列表
    this.getjobtypeHandle();
    this.gettrainingtypeHandle();
    this.getDpartmentsHandle();
    this.gettrainingsHandle();
  },
  methods: {
    // 获取培训列表
    async gettrainingsHandle() {
      const { data: res } = await gettrainings({ page: 1, limit: 99 });
      if (res.data.list.length > 0) {
        const newArry = res.data.list.map((item) => {
          let startDate = item.train_start_time.split(" ")[0];
          let endDate = item.train_end_time.split(" ")[0];
          return {
            id: item.id,
            disabled: item.disabled,
            name: `${item.name} 培训时间:${startDate}-${endDate} 培训地点:${item.area}`,
          };
        });
        this.phaseList = newArry;
      }
    },
    // 获取职业类型
    async getjobtypeHandle() {
      const res = await getDictionaries("job_type");
      this.zubieList = res.data.data;
    },
    // 获取培训类型
    async gettrainingtypeHandle() {
      const res = await getDictionaries("training_type");
      this.training_typeList = res.data.data;
    },
    dialog2Show() {
      this.dialog2 = true;
    },
    // 修改用户信息
    submitForm2(formName) {
      this.$refs[formName].validate(async (valid) => {
        const newData = {...this.ruleForm}
        delete newData.training_id
        delete newData.type
        delete newData.cert_image
        delete newData.unit_cert_image
        const { data: res } = await updateUserInfo(newData);
        this.$message.success(res.msg);
      });
    },
    // 报名参赛提交
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.hospitalListIsShow) {
            return this.$message("请选择您的医院");
          }
          if (this.count === 0) {
            this.ruleForm.hospital_id = 0;
          }
          if (
            this.ruleForm.cert_image == "" &&
            this.ruleForm.unit_cert_image == ""
          ) {
            document.documentElement.scrollTop = 800;
            return this.$message("工作证明和单位证明请至少上传一个");
          }

          const { data: res } = await setBaoming(this.ruleForm);
          if (res.code !== 1) {
            return this.$message.error(res.msg);
          }
          this.$message.success(res.msg);
          this.$router.push({ name: "userstate" });
        } else {
          document.documentElement.scrollTop = 500;
          return false;
        }
      });
    },

    // 医院列表触底
    async hospitalDel() {
      if (this.mapList.hospital.length < this.count) {
        this.pageSize.page++;
        // 获取医院信息
        const { data: res } = await searchHospital({
          keyword: this.ruleForm.hospital_name,
          ...this.pageSize,
        });
        if (res.code === 1) {
          this.mapList.hospital.push(...res.data.list);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      } else {
        return;
      }
    },
    // 输入医院
    hospitalChange() {
      this.hospitalListIsShow = true;
      this.gethospital({
        ...this.pageSize,
        keyword: this.ruleForm.hospital_name,
      });
    },
    hospitalChange2() {
      this.ruleForm.hospital_id = 0;
    },
    // 选择医院
    choiceHospital(item) {
      this.ruleForm.hospital_name = item.name;
      this.ruleForm.hospital_id = item.id;
      this.hospitalListIsShow = false;
    },
    // 关闭医院列表
    offHospital() {
      this.hospitalListIsShow = false;
    },
    // 获取医院列表
    async gethospital(data) {
      const { data: res } = await searchHospital(data);
      this.mapList.hospital = res.data.list;
      this.count = res.data.total;
      if (this.count === 0) {
        this.hospitalListIsShow = false;
        this.ruleForm.hospital_id = "";
      }
    },
    // 获取用户信息
    async getUserInfoHandle() {
      const { data: res } = await getBmInfo();
      const userInfo = res.data;
      for (const key in this.ruleForm) {
        this.ruleForm[key] = userInfo[key];
        if (
          this.ruleForm[key] == 0 ||
          this.ruleForm[key] == null ||
          this.ruleForm[key] == undefined
        ) {
          this.ruleForm[key] = "";
        }
      }
      console.log(this.ruleForm);
    },
    // 职业类型切换
    mygroupChange(id) {
      this.ruleForm.job_type = id;
    },
    // 培训类型切换
    mygroupChange2(id) {
      this.ruleForm.type = id;
    },
    // 获取科室列表
    async getDpartmentsHandle() {
      const res = await getDpartments(1);
      this.DepartmentList = res.data.data;
    },

    // 选择省/市信息
    provinceChange() {
      this.ruleForm.city_id = "";
      this.ruleForm.district_id = "";
      this.mapList.city = [];
      this.mapList.area = [];
    },
    cityChange() {
      this.ruleForm.district_id = "";
      this.mapList.area = [];
    },

    // 获取省份信息
    async getProvince(id) {
      const { data: res } = await getAreas(id);
      if (res.code == 1) {
        this.mapList.province = res.data;
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
      }
    },

    // 图片上传成功回调
    handleAvatarSuccess(res) {
      if (res.code !== 1) {
        return this.$message(res.msg);
      }
      this.ruleForm.cert_image = res.data.url;
    },
    handleAvatarSuccess2(res) {
      if (res.code !== 1) {
        return this.$message(res.msg);
      }
      this.ruleForm.unit_cert_image = res.data.url;
    },
    beforeAvatarUpload(file) {
      const isImage =
        file.type == "image/png" ||
        file.type == "image/jpg" ||
        file.type == "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传工作证明图片只能是 JPG 和 PNG格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传单位证明图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },
    // 关闭对话框
    handleClose() {
      this.dialogVisible = false;
    },
    async getTitlesHandle(id) {
      const res = await getTitles(id);
      this.zhichengList = res.data.data;
    },
  },
  // 监听器
  watch: {
    "ruleForm.province_id": async function (newV) {
      if (newV == "") {
        return;
      }
      // 获取市信息
      const { data: res } = await getAreas(newV);
      if (res.code == 1) {
        this.mapList.city = res.data;
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
      }
    },
    "ruleForm.city_id": async function (newV) {
      if (newV == "") {
        return;
      }
      // 获取区信息
      const { data: res } = await getAreas(newV);
      if (res.code == 1) {
        this.mapList.area = res.data;
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
      }
    },
    "ruleForm.hospital_name": function (newV) {
      if (newV == "") {
        this.hospitalListIsShow = false;
      }
    },
    "ruleForm.job_type": function (newV) {
      this.getTitlesHandle(newV);
    },
  },
};
</script>
<style scoped lang="scss">
.signup {
  background: #fff;
  overflow: hidden;
  .martop20 {
    margin-top: 15px;
  }
  .textcontent {
    margin: 0px auto;
    @media screen and (max-width: 520px) {
      width: 100%;
    }
    h2 {
      font-size: 26px;
      text-align: center;
      color: #05258e;
      margin-bottom: 10px;
      @media screen and (max-width: 520px) {
        padding-top: 20px;
        font-size: 16px;
      }
    }
    .span {
      display: block;
      margin: 0px auto;
      width: 24px;
      height: 4px;
      background: #05258e;
      border-radius: 2px;
      margin-bottom: 38px;
      @media screen and (max-width: 520px) {
        height: 2px;
        margin-bottom: 18px;
      }
    }
    .box {
      width: 1269px;
      @media screen and (max-width: 520px) {
        width: 100%;
        height: 100%;
        padding: 0;
        margin-bottom: 50px;
      }
      background: #ffffff;
      padding: 50px 0;
      margin-bottom: 150px;
      .text {
        p {
          font-size: 20px;
          color: #39373b;
          line-height: 35px;
          padding-bottom: 20px;
          @media screen and (max-width: 520px) {
            font-size: 14px;
            line-height: 20px;
          }
          a {
            color: #05258e;
            font-weight: 600;
          }
          .span1 {
            padding: 20px 0 15px 130px;
            @media screen and (max-width: 520px) {
              padding: 10px 0 10px 30px;
            }
          }
          span {
            display: block;
          }
        }
      }
    }
  }
  .myswitch {
    position: absolute;
    right: 400px;
    top: 10px;
    @media screen and (max-width: 540px) {
      right: 10px;
    }
  }
  ::v-deep .avatar {
    height: 108px !important;
  }
  .hospitalList {
    position: absolute;
    left: 0;
    z-index: 999;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    width: 400px;
    padding: 10px 0;
    background-color: #fff;
    @media screen and (max-width: 540px) {
      width: 280px;
    }
    ul {
      height: 280px;
      overflow-y: scroll;
      li {
        box-sizing: border-box;
        cursor: pointer;
        @media screen and (max-width: 540px) {
          padding: 5px 0;
        }
        p {
          padding: 0 15px;
          @media screen and (max-width: 540px) {
            line-height: 25px;
          }
        }
      }
      li:hover {
        background-color: #eee;
      }
    }
  }
  .el-radio {
    padding: 5px 0;
  }

  .content {
    margin: auto;
    padding: 30px 40px;
    background-color: #fff;
    @media screen and (max-width: 540px) {
      width: 100%;
      padding:0
    }
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #05258e;
      height: 55px;
      line-height: 55px;
      text-align: left;
      border-bottom: 1px solid #05258e;
      margin-bottom: 20px;
    }
    .form {
      box-sizing: border-box;
      ::v-deep .el-form-item__label {
        color: #05258e;
        font-weight: 600;
        font-size: 15px;
      }
      .inputWidth {
        width: 100%;
        @media screen and (max-width: 540px) {
          width: 100%;
        }
      }
      .groupBtns {
        display: flex;
        button {
          height: 40px;
          width: 250px;
          @media screen and (max-width: 540px) {
            font-size: 12px;
            line-height: 14px;
            padding: 5px;
          }
          line-height: 40px;
          background-color: #fff;
          border: 1px solid #dcdfe6;
          list-style: none;
          margin-right: 20px;
          font-size: 15px;
          color: #47474e;
          cursor: pointer;
        }
        .glbtn {
          background-color: #05258e !important;
          color: #fff !important;
        }
      }
      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: #05258e;
      }
      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        background-color: #05258e;
        border-color: #05258e !important;
      }
      .adress {
        display: flex;
        .el-select {
          margin-right: 6px;
        }
      }
      .hospital {
        .el-select {
          width: 662px;
          margin-top: 16px;
        }
      }
      // 图片上传
      .uploader {
        padding-bottom: 30px;
        display: flex;
        @media screen and (max-width: 540px) {
          display: block;
          .avatar-uploader {
            margin-bottom: 40px;
          }
        }
        ::v-deep .el-upload {
          // border: 1px dashed #d9d9d9;
          border-radius: 6px;
          background-color: #eeeeee;
          cursor: pointer;
          position: relative;
          margin-right: 20px;
          .clear {
            z-index: 999;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            color: #fff;
            background-color: #39373b3f;
          }
        }
        .tit {
          position: absolute;
          bottom: -40px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 99;
          i {
            z-index: 99;
          }
        }
        .tit2 {
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 999;
          color: #409eff;
          width: 100%;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 108px;
          line-height: 108px;
          text-align: center;
        }
        .avatar {
          width: 178px;
          height: 178px;
          display: block;
        }
      }
      .height {
        height: 10px;
        width: 100%;
        background-color: #f5f5f5;
        margin-bottom: 20px;
      }
      // 视频上传
      .videoUP {
        ::v-deep .el-form-item__label {
          color: #05258e !important;
        }
        ::v-deep .el-upload-dragger {
          width: 260px;
        }
        .tishi {
          padding: 0 0 32px 0;
          .btnText {
            width: 100px;
            height: 35px;
            background: #f5f5f5;
            border: 1px solid #dcdcdc;
            border-radius: 4px;
            padding: 5px 14px;
            cursor: pointer;
          }
        }
      }
      // 提交表单
      .submit {
        display: block;
        background-color: #293f8e;
        margin: auto;
        width: 100%;
        line-height: 1.2;
      }
    }
  }
}
</style>
